import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Artikel',
    to: '/artikel'
  }, {
    name: 'Kategorien',
    to: '/#kategorien'
  }, {
    name: 'Über uns',
    to: '/#ueber-uns'
  }];
  const handleNavClick = (to: string) => {
    setIsMobileMenuOpen(false);
    if (to.startsWith('/#')) {
      const id = to.slice(2);
      if (location.pathname === '/') {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <header className="sticky top-0 z-50 w-full bg-vita-cream/80 backdrop-blur-md border-b border-vita-border transition-all duration-300" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="flex justify-between items-center h-24 md:h-20" data-id="element-168">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-169">
            <Link to="/" className="flex flex-col items-start py-2 -ml-1 pl-1" data-id="element-170">
              <img src="https://cdn.magicpatterns.com/uploads/8Z3c4xx4DwUTrp4PhuSqRZ/3.svg" alt="VitaFrukt Logo" className="h-10 md:h-14 w-auto object-contain" data-id="element-171" />
              <span className="text-[9px] md:text-[11px] text-vita-text-light tracking-[0.15em] uppercase mt-1.5 md:mt-2" style={{
              fontFamily: 'Georgia, "Times New Roman", serif'
            }} data-id="element-172">
                Ihr vertrauenswürdiges Gesundheitsmagazin
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-173">
            {navLinks.map(link => link.to.startsWith('/#') ? <Link key={link.name} to={link.to} onClick={() => handleNavClick(link.to)} className="text-vita-text-muted hover:text-vita-green-deep font-medium transition-colors duration-200" data-id="element-174">
                  {link.name}
                </Link> : <Link key={link.name} to={link.to} className={`font-medium transition-colors duration-200 ${location.pathname.startsWith(link.to) ? 'text-vita-green-deep' : 'text-vita-text-muted hover:text-vita-green-deep'}`} data-id="element-175">
                  {link.name}
                </Link>)}
          </nav>

          {/* Mobile Menu Button */}
          <div className="flex items-center md:hidden" data-id="element-176">
            <button type="button" className="text-vita-text-muted hover:text-vita-green-deep focus:outline-none p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-expanded={isMobileMenuOpen} aria-label="Toggle navigation menu" data-id="element-177">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-178" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-179" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Panel */}
      <AnimatePresence data-id="element-180">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="md:hidden bg-vita-cream border-b border-vita-border overflow-hidden" data-id="element-181">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-vita" data-id="element-182">
              {navLinks.map(link => <Link key={link.name} to={link.to} className="block px-3 py-4 text-base font-medium text-vita-text-muted hover:text-vita-green-deep hover:bg-vita-green-pale rounded-soft transition-colors duration-200" onClick={() => handleNavClick(link.to)} data-id="element-183">
                  {link.name}
                </Link>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}